import { createClient } from 'contentful'

export const createContentfulClient = () =>
  createClient({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE || 'space',
    accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN || 'access-token',
    host: process.env.NEXT_PUBLIC_CONTENTFUL_HOST || 'cdn.contentful.com',
  })
